import React, { useEffect, useState } from "react";
import { Button, Table } from "react-bootstrap";
import { integer } from "aws-sdk/clients/storagegateway";


const SettingsList = (props: any) => {
    const [sources, setSources] = useState<any>([]);

    useEffect(() => {
        setSources(props.sources);
    }, [props.sources]);

    const editSource = (source:any) => {
        console.log("102821 editSource > source", source)
        console.log("102821 editSource > props", props)
        if(props.onSelectedSourceId) {
            props.onSelectedSourceId(source.id);
        }
    }
    console.log("102821 props", props)
    return (
        <>
        <Table striped bordered hover variant="dark">
            <thead>
                <tr>
                    <th></th>
                    <th>Title</th>
                    <th>Collection ID</th>
                    <th>Min Date</th>
                    <th>Max Date</th>
                </tr>
            </thead>
            <tbody>
                {
                    sources.map((source:any, index:integer) => (
                        <tr key={index}>
                            <td>
                                <Button 
                                    variant="primary"
                                    size="sm"
                                    onClick={() => editSource(source)}>
                                        Edit
                                </Button>
                            </td>
                            <td>{source.title}</td>
                            <td>{source.collection_id}</td>
                            <td>{source.min_date}</td>
                            <td>{source.max_date}</td>
                        </tr>
                    ))
                }
            </tbody>
            </Table>
        </>
    );
}

export default SettingsList;